export const ACTION_BUTTONS_DIAMETER = '48px';
